import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppNotification } from '@fuse/types/notification';
import { AuthService } from '../auth/auth.service';
import { timer } from 'rxjs';
import { Router } from '@angular/router';

export interface IsNewResponse {
    data: number;
}

@Injectable()

export class RequestService implements OnDestroy {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;

    timer: Observable<number>;
    timerSubscription: Subscription;

    onRequestsChanged: Subject<any>;

    // fromNotifications = false;

    searchText: string;

    constructor(
        public _http: HttpClient,
        private _authService: AuthService,
        private _router: Router
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        this.onRequestsChanged = new Subject();

    }

    /**
     * Public methods
     */

    public listSubmittedRequests(companyId, page: number = 1, limit: number = 10, orderBy: string = 'created_at', order: string = 'desc', search: string = ''): Promise<any> {

        const params = {
            limit: limit,
            order_by: 'id',
            order: order
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/erp/' + companyId + '/employee-request/listing?page=' + page, params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                    }, reject);
        });

    }

    public createRequest(requestId: number, comment: string, company: string): Promise<any> {

        const params = {
            employee_request_id: requestId,
            employee_comment: comment
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/erp/' + company + '/employee-request/submit', params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onRequestsChanged.next(response);
                        // this.listSubmittedRequests(company);
                        resolve(response);
                    }, reject);
        });
    }

    public getAllRequestTypes(company: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/portal/erp/' + company + '/employee-request/get-requests')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        resolve(response);
                    }, reject);
        });
    }
    
    /**
     * Lifecycle hooks
     */

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
